import { render, staticRenderFns } from "./DoyangGroupAttendance.vue?vue&type=template&id=22b09638"
import script from "./DoyangGroupAttendance.vue?vue&type=script&lang=js"
export * from "./DoyangGroupAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports